import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import FloatingButtons from '@/pages/home/components/FloatingButtons';
import Accordion from '@/components/base/Accordion';
import ProgressiveImage from '@/components/base/ProgressiveImage';

const features = [
  { icon: 'ri-price-tag-3-line', title: 'Uygun Fiyat', desc: 'Sadece yüklediğiniz kadar ödeyerek taşıma maliyetlerinizi minimuma indirin.' },
  { icon: 'ri-calendar-check-line', title: 'Düzenli Seferler', desc: 'Haftalık düzenli sefer takvimimizle yükünüz güvenle ve zamanında ulaşır.' },
  { icon: 'ri-map-pin-2-line', title: 'Kapıdan Kapıya', desc: "Türkiye'nin 81 ilinden Avrupa'nın 27 ülkesine kapıdan kapıya teslimat garantisi." },
  { icon: 'ri-shield-check-line', title: 'Sigortalı Taşıma', desc: 'Tüm parsiyel yüklerimiz kapsamlı kargo sigortasıyla güvence altındadır.' },
];

const faqs = [
  { q: 'Minimum yük miktarı nedir?', a: 'Parsiyel taşımacılıkta minimum yük sınırı yoktur. 1 koliden birkaç palete kadar her boyutu taşıyoruz.' },
  { q: 'Teslimat süresi ne kadar?', a: "Avrupa'nın ülkesine göre ortalama 5–10 iş günü içinde teslimat yapılmaktadır. Almanya, Avusturya, Hollanda gibi yakın ülkelere 5–7, İspanya, Portekiz gibi uzak ülkelere 8–10 iş günü sürmektedir." },
  { q: 'Fiyatlandırma nasıl yapılıyor?', a: 'Fiyat; yükün ağırlığı, hacmi ve gönderim adresine göre hesaplanır. WhatsApp üzerinden fiyat teklifi alabilirsiniz.' },
  { q: 'Takip imkânı var mı?', a: 'Evet, yükünüz yola çıktığında WhatsApp üzerinden anlık bilgilendirme yapıyoruz.' },
];

export default function ParsToday() {
  return (
    <main className="font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-brand-navy overflow-hidden">
        <div className="absolute inset-0">
          <ProgressiveImage
            src="/media/search-image-11c8212785.jpg"
            alt="Parsiyel Taşımacılık"
            className="object-cover object-top opacity-20"
            priority
          />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-2 mb-6 flex-wrap">
            <Link to="/" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Anasayfa</Link>
            <span className="text-white/30 text-sm">/</span>
            <Link to="/hizmetlerimiz" className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">Hizmetlerimiz</Link>
            <span className="text-white/30 text-sm">/</span>
            <span className="text-brand-orange text-sm font-medium">Parsiyel Taşımacılık</span>
          </div>
          <span className="inline-flex items-center gap-2 bg-brand-orange/20 border border-brand-orange/30 text-brand-orange text-xs font-semibold px-3 py-1 rounded-full mb-5 uppercase tracking-widest">
            <i className="ri-box-3-line"></i> Hizmet 01
          </span>
          <h1 className="text-white font-heading font-bold text-4xl md:text-5xl mb-6 leading-tight">
            Parsiyel Taşımacılık<br />
            <span className="text-brand-orange">Türkiye&apos;den Avrupa&apos;nın 27 Ülkesine</span>
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
            Küçük veya orta hacimli yüklerinizi başka müşterilerimizin kargolarıyla birleştirerek çok daha uygun maliyetle Avrupa&apos;nın istediğiniz ülkesine ulaştırıyoruz. Türkiye&apos;nin 81 ilinden kapıdan kapıya teslimat.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://wa.me/905322376576?text=Merhaba%2C%20parsiyel%20ta%C5%9F%C4%B1mac%C4%B1l%C4%B1k%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-whatsapp hover:bg-whatsapp-dark text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></span>
              Fiyat Teklifi Al
            </a>
            <Link
              to="/iletisim"
              className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/20 hover:bg-white/20 text-white px-6 py-3 rounded-md text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-send-line text-base"></i></span>
              Form ile Ulaşın
            </Link>
          </div>
        </div>
      </section>

      {/* Visual + Features */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative rounded-2xl overflow-hidden h-[360px] md:h-[440px]">
              <ProgressiveImage
                src="/media/search-image-0a3951f599.jpg"
                alt="Parsiyel Taşımacılık"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/95 rounded-xl p-4 flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-lg flex-shrink-0">
                    <i className="ri-box-3-line text-xl"></i>
                  </div>
                  <div>
                    <div className="text-brand-navy font-heading font-bold text-sm">Minimum Yük Sınırı Yok</div>
                    <div className="text-gray-400 text-xs mt-0.5">1 koliden birkaç palete kadar taşıyoruz</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Neden Parsiyel?</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-8">Parsiyel Taşımacılığın Avantajları</h2>
              <div className="flex flex-col gap-5">
                {features.map((f, i) => (
                  <div key={i} className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-brand-orange/20 transition-all duration-300">
                    <div className="w-11 h-11 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl flex-shrink-0">
                      <i className={`${f.icon} text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-brand-navy font-heading font-bold text-sm mb-1">{f.title}</h3>
                      <p className="text-gray-400 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Süreç</p>
              <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl mb-10">Nasıl Çalışır?</h2>
              <div className="flex flex-col gap-6">
                {[
                  { step: '01', title: 'Teklif Alın', desc: 'WhatsApp veya form üzerinden yük bilgilerini paylaşın, fiyat teklifiniz anında gelsin.', icon: 'ri-message-3-line' },
                  { step: '02', title: 'Yükü Teslim Edin', desc: 'Belirlenen depo adresimize yükünüzü getirin veya adresinizden alabiliriz.', icon: 'ri-truck-line' },
                  { step: '03', title: 'Sefere Katılın', desc: "Haftalık düzenli sefer takviminde yükünüz Avrupa'daki hedef ülkeye doğru yola çıkar.", icon: 'ri-route-line' },
                  { step: '04', title: 'Teslim Alın', desc: 'Alıcı kapısına kadar güvenli teslimat yapılır, sizi anlık bilgilendiririz.', icon: 'ri-checkbox-circle-line' },
                ].map((s, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="flex flex-col items-center flex-shrink-0">
                      <div className="w-12 h-12 flex items-center justify-center bg-brand-navy text-white rounded-full">
                        <i className={`${s.icon} text-lg`}></i>
                      </div>
                      {i < 3 && <div className="w-0.5 h-8 bg-gray-200 mt-2"></div>}
                    </div>
                    <div className="pt-2">
                      <span className="text-brand-orange font-bold text-xs uppercase tracking-widest">{s.step}</span>
                      <h4 className="text-brand-navy font-heading font-bold text-base mt-0.5 mb-1">{s.title}</h4>
                      <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative rounded-2xl overflow-hidden h-[420px] md:h-[520px]">
              <ProgressiveImage
                src="/media/search-image-e7957c7f33.jpg"
                alt="Parsiyel Taşıma Süreci"
                className="object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-brand-navy/90 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-brand-orange animate-pulse flex-shrink-0"></div>
                    <p className="text-white text-sm font-medium">Haftalık düzenli seferler — Türkiye&apos;den Avrupa&apos;ya</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="mb-12 text-center">
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">SSS</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">Sık Sorulan Sorular</h2>
            <p className="text-gray-400 text-sm mt-3">Merak ettiklerinizi tıklayarak öğrenin</p>
          </div>
          <Accordion items={faqs} />
        </div>
      </section>

      {/* Other Services */}
      <section className="py-16 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <p className="text-gray-400 text-sm mb-6 font-medium">Diğer Hizmetlerimiz</p>
          <div className="flex flex-wrap gap-3">
            {[
              { label: 'Komple Araç', href: '/hizmetlerimiz/komple-arac', icon: 'ri-truck-line' },
              { label: 'Ev & Ofis Taşıma', href: '/hizmetlerimiz/ev-ofis-tasima', icon: 'ri-home-4-line' },
              { label: 'Hızlı Kargo', href: '/hizmetlerimiz/hizli-kargo', icon: 'ri-flashlight-line' },
            ].map((s) => (
              <Link
                key={s.href}
                to={s.href}
                className="inline-flex items-center gap-2 border border-gray-200 text-brand-navy hover:border-brand-orange hover:text-brand-orange px-4 py-2.5 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center"><i className={`${s.icon} text-base`}></i></span>
                {s.label}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </main>
  );
}
